import React from 'react'
import "../discover/Discover.css"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Container, Row } from 'react-bootstrap';
import ReusableDiscover from '../organic9-reusable/ReusableDiscover';
function Discover() {
    return (
      <section id="discover">
        <Container>
          <h1>Discover Our Products</h1>
          <Tabs defaultActiveKey="featured" id="justify-tab-example" className="mb-3" justify>
            <Tab eventKey="featured" title="Fruits">
              <Row style={{rowGap: "20px"}}>
                <ReusableDiscover img="imeges/desktop 9/blackberry-small.svg" />
                <ReusableDiscover img="imeges/desktop 9/broccoli small.svg" />
                <ReusableDiscover img="imeges/desktop 9/apricot small.svg" />
                <ReusableDiscover img="imeges/desktop 9/tomato small.svg" />
                <ReusableDiscover img="imeges/desktop 9/strawberry small.svg" />
                <ReusableDiscover img="imeges/desktop 9/kicha small.svg" />
              </Row>
            </Tab>
            <Tab eventKey="latest" title="Vegetable">
            <Row style={{rowGap: "20px"}}>
                <ReusableDiscover img="imeges/desktop 9/blackberry-small.svg" />
                <ReusableDiscover img="imeges/desktop 9/broccoli small.svg" />
                <ReusableDiscover img="imeges/desktop 9/apricot small.svg" />
                <ReusableDiscover img="imeges/desktop 9/tomato small.svg" />
                <ReusableDiscover img="imeges/desktop 9/strawberry small.svg" />
                <ReusableDiscover img="imeges/desktop 9/kicha small.svg" />
              </Row>
            </Tab>
            <Tab eventKey="best-seller" title="Juice">
            <Row style={{rowGap: "20px"}}>
                <ReusableDiscover img="imeges/desktop 9/blackberry-small.svg" />
                <ReusableDiscover img="imeges/desktop 9/broccoli small.svg" />
                <ReusableDiscover img="imeges/desktop 9/apricot small.svg" />
                <ReusableDiscover img="imeges/desktop 9/tomato small.svg" />
                <ReusableDiscover img="imeges/desktop 9/strawberry small.svg" />
                <ReusableDiscover img="imeges/desktop 9/kicha small.svg" />
              </Row>
            </Tab>
            <Tab eventKey="special" title="Meat">
            <Row style={{rowGap: "20px"}}>
                <ReusableDiscover img="imeges/desktop 9/blackberry-small.svg" />
                <ReusableDiscover img="imeges/desktop 9/broccoli small.svg" />
                <ReusableDiscover img="imeges/desktop 9/apricot small.svg" />
                <ReusableDiscover img="imeges/desktop 9/tomato small.svg" />
                <ReusableDiscover img="imeges/desktop 9/strawberry small.svg" />
                <ReusableDiscover img="imeges/desktop 9/kicha small.svg" />
              </Row>
            </Tab>
          </Tabs>
        </Container>
      </section>
    );
  }
  
  export default Discover
